import styled, { css } from 'styled-components';
import { Utils } from '@hiro-ui/bootstrap';

interface DefaultTemplateDivProps {
  hasToC?: boolean;
  hasSidebar?: boolean;
}

export const DefaultTemplateDiv = styled.div<DefaultTemplateDivProps>`
  position: relative;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;

  & .ulist code,
  & p > code {
    color: #e90;
  }

  /* dl > dt {
    color: ${({ theme }) => theme.colors.primary.default};
  } */

  /* dl > dd {
    border-left: 2px solid ${({ theme }) =>
    theme.colors.primary.default};
    padding-left: 16px;
  } */

  .admonitionblock {
    margin: 1em 0;

    table {
      table-layout: fixed;
      width: 100%;

      td:first-child {
        width: 60px;
        text-align: center;
      }
    }

    .content {
      padding-left: 20px;
      border-left: 1px solid ${({ theme }) => theme.greyscale.medium};
    }

    .icon {
      font-size: 42px;
    }

    .icon > .fa.icon-note {
      color: ${({ theme }) => theme.colors.blue.default};
      &:before {
        content: '\f05a';
      }
    }

    .icon > .fa.icon-tip {
      &:before {
        content: '\f0eb';
      }
    }

    .icon > .fa.icon-important {
      color: ${({ theme }) => theme.colors.red.default};
      &:before {
        content: '\f06a';
      }
    }

    .icon > .fa.icon-warning {
      color: ${({ theme }) => theme.colors.orange.default};
      &:before {
        content: '\f071';
      }
    }

    .icon > .fa.icon-caution {
      color: ${({ theme }) => theme.colors.orange.default};
      &:before {
        content: '\f06d';
      }
    }
  }

  table.tableblock {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;

    tr td:first-child {
      text-align: center;
    }

    th,
    tr:nth-child(even) {
      background-color: #f2f2f2;
    }

    &,
    th,
    td {
      border: 1px solid ${({ theme }) => theme.greyscale.medium};
    }

    td {
      padding: 0 0.5em;
    }
  }

  & > .paragraph {
    width: 100%;
  }

  & .sectionbody .image {
    & img {
      display: block;
    }

    &.left {
      float: left;
      width: 30%;
      max-width: 250px;

      & img {
        padding: 0 3em 0 0;
        box-sizing: border-box;
        width: 100%;
        transform: translateY(-2.5em);
      }
    }
  }

  & .sect1.left {
    & h2::before {
      content: '';
      float: left;
      width: 30%;
      max-width: 250px;
      height: 1px;
    }

    & .ulist {
      margin-left: 30%;
    }
  }

  & .sect1:not(:last-child) {
    margin-bottom: 3rem;
  }

  & .sect2:not(:last-child) {
    margin-bottom: 2rem;
  }

  & .sectionbody .listingblock {
    display: flex;
    flex-flow: column nowrap;
    margin: 1em 0;

    & > .title {
      order: 2;
      text-align: center;
    }
  }

  & > div:not(.toc) a {
    color: ${({ theme }) => theme.colors.primary.default};
  }

  .sect1 {
    width: 100%;
  }

  .imageblock > .content {
    text-align: center;

    & img {
      ${Utils.sm} {
        padding: 0;
      }

      padding: 0 2em;
    }
  }

  span.image.center > img {
    margin: 0 auto;
  }

  img {
    max-width: 100%;
    box-sizing: border-box;
  }

  /** Code boxes */
  & button {
    border-radius: 3em;
    padding: 0.5em 1.5em;

    ${({ theme }) => Utils.primary({ theme, color: 'primary' })}
    ${({ theme }) => Utils.clickable({ theme, color: 'primary' })}
  }

  & .code-toolbar {
    position: relative;

    & > .toolbar {
      position: absolute;
      bottom: 0;
      right: 0;
      padding: 0.5em;

      & button {
        display: none;
      }
    }
  }

  & .code-toolbar:hover {
    & > .toolbar button {
      display: block;
    }
  }

  ${({ hasSidebar, hasToC }) =>
    (hasSidebar || hasToC) &&
    css`
      & .sect1,
      #preamble {
        position: relative;

        ${Utils.sm} {
          margin-left: 0;
          margin-right: 0;
        }

        margin: 0 300px;
      }
    `}

  /** Table of Contents */
  ${({ hasToC, hasSidebar }) =>
    hasToC &&
    css`
      main.scrolled & .toc > .sectlevel1 {
        position: fixed;
        top: 30px;
        right: 0;
        max-height: calc(100vh - 60px);
        overflow-y: auto;
      }

      #SubNav {
        display: none;
      }

      .toc {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 100;
        font-size: 0.9em;

        & ul {
          list-style: none;
          margin: 0;
          padding: 0 20px;
        }

        & #toctitle {
          display: none;
        }

        & > .sectlevel1 {
          margin: 0;
          border-left: 1px solid ${({ theme }) => theme.greyscale.medium};
          overflow: auto;
          box-sizing: border-box;

          ${Utils.sm} {
            display: none;
          }

          width: 276px;
        }

        & a {
          display: block;
          position: relative;
          padding-left: 20px;
          padding-bottom: 1em;
          text-decoration: none;

          &::before {
            content: '\f061';
            font-family: 'FontAwesome';
            color: ${({ theme }) => theme.colors.white.default};
            position: absolute;
            left: 0;
            top: 4px;
            border-radius: 50%;
            background-color: ${({ theme }) => theme.greyscale.light};
            width: 14px;
            height: 14px;
            font-size: 8px;
            line-height: 14px;
            text-align: center;
            overflow: hidden;
          }

          &:hover {
            color: ${({ theme }) => theme.colors.primaryText.active};

            &::before {
              background-color: ${({ theme }) => theme.colors.primary.default};
            }
          }
        }
      }
    `}
`;

export const IndexTemplateDiv = styled(DefaultTemplateDiv)`
  .sect1 {
    width: 100%;
  }

  &,
  .sect1:not(.left) > .sectionbody {
    display: flex;
    flex-flow: row wrap;
    justify-content: start;

    & .quoteblock {
      padding: 1em 0;

      & > blockquote {
        height: 100px;
        width: 250px;
        display: flex;
        margin: 0 auto;
        border-radius: ${({ theme }) => theme.sizes.borderRadius};
        background-color: ${({ theme }) => theme.greyscale.lighter};
        border: 1px solid ${({ theme }) => theme.greyscale.light};
        position: relative;

        & > .paragraph {
          display: flex;
          align-items: center;
          justify-content: center;

          & img {
            width: 48px;
            margin: 0.75rem;
          }

          & > p {
            display: flex;
            flex-flow: column nowrap;
            font-size: 11px;
            width: 100%; /* Fix IE11 */

            & > strong {
              font-size: 14px;
              font-weight: 300;
              margin-bottom: 0.5em;
            }

            & > a {
              position: absolute;
              top: 0;
              left: 0;
              color: transparent;
              right: 0;
              bottom: 0;
            }

            & > a::after {
              content: '\f061';
              font-family: 'FontAwesome';
              color: ${({ theme }) => theme.colors.white.default};
              bottom: 0;
              position: absolute;
              right: 0;
              margin: 0.5rem;
              border-radius: 50%;
              background-color: ${({ theme }) => theme.greyscale.light};
              width: 20px;
              height: 20px;
              font-size: 14px;
              line-height: 20px;
              text-align: center;
              overflow: hidden;
            }
          }
        }

        & > .paragraph:not(:first-child) {
          flex: 1;

          & > p {
            margin-right: 2em;
          }
        }
      }

      & > blockquote:hover {
        border-color: ${({ theme }) => theme.colors.primary.default};

        & > .paragraph > p > a::after {
          background-color: ${({ theme }) => theme.colors.primary.default};
        }
      }

      flex: 0 0 ${({ theme }) => theme.sizes.width.xl / 4}px;

      ${Utils.lg} {
        flex: 0 0 ${({ theme }) => theme.sizes.width.lg / 3}px;
      }

      ${Utils.md} {
        flex: 0 0 ${({ theme }) => theme.sizes.width.md / 2}px;
      }

      ${Utils.sm} {
        flex: 1 1 auto;
      }
    }
  }
`;

export const HomeTemplateDiv = styled(IndexTemplateDiv)``;
